module.exports = "#version 100\r\nprecision highp float;\r\n\r\nuniform mat4 u_viewProjectionMatrix;\r\n\r\nattribute vec3 a_position;\r\nattribute vec3 a_color;\r\n\r\nvarying vec3 v_color;\r\n\r\nvoid main() {\r\n    gl_Position = u_viewProjectionMatrix * vec4(a_position, 1.0);\r\n    v_color = a_color;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/wireframe.vert.glsl
// module id = 36
// module chunks = 0